/* 24GAMEKEYS — gk-qty-limit.js (v38)
   Limite anti-fraude : 3 exemplaires maximum PAR PRODUIT.
   Aucun plafond sur le nombre total de cles par commande : un client peut
   acheter 3 cles de chaque jeu, sur autant de jeux qu'il veut.

   ----------------------------------------------------------------------------
   HISTORIQUE DES CORRECTIFS — 2 aout 2026
   Le panier renvoyait "There was an error while updating your cart" et le bouton
   Check out ne partait pas. Trois causes, toutes traitees ici :

   1. window.fetch etait relaye par  origFetch.apply(this, arguments).
      Le code panier de Shopify appelle fetch(...) sans prefixe, donc `this` vaut
      undefined et fetch refuse d'etre invoque ainsi : "Illegal invocation".
      Toute requete panier echouait. -> on force window comme contexte.

   2. /cart/update etait intercepte alors que cette route sert aussi a enregistrer
      les attributs de commande (consentement UE). -> retiree de l'interception.

   3. Un plafond de 3 cles PAR COMMANDE bloquait le checkout. Il comptait les
      champs input[name="updates[]"] du DOM, or le theme en rend plusieurs jeux
      (tableau desktop + liste mobile) : un panier de 2 cles etait compte 4+.
      -> supprime entierement, la regle metier etant 3 par produit, pas par
      commande. C'est aussi ce qui cassait le checkout.
   ----------------------------------------------------------------------------

   Couvre trois surfaces :
     1. Champs de quantite (page produit + panier) : attribut max + clamp
     2. Boutons "+" : desactives une fois la limite atteinte
     3. Requetes /cart/add et /cart/change : quantite plafonnee avant envoi,
        ce qui bloque aussi les doubles clics et les ajouts rapides

   LIMITE CONNUE : controle cote client. Il arrete un acheteur normal, pas
   quelqu'un qui appelle l'API panier directement. Pour un blocage reel il faut
   une Shopify Function de validation panier (app custom, plan superieur). */
(function () {
  var MAX_PER_ITEM = 3;
  var MSG = 'Limit: ' + MAX_PER_ITEM + ' keys maximum per product.';

  function clampInputs(root) {
    (root || document).querySelectorAll('input.quantity__input, input[name="quantity"], input[name="updates[]"]').forEach(function (input) {
      input.setAttribute('max', MAX_PER_ITEM);
      var v = parseInt(input.value, 10);
      if (!isNaN(v) && v > MAX_PER_ITEM) {
        input.value = MAX_PER_ITEM;
      }
      var wrapper = input.closest('quantity-input, .quantity');
      if (wrapper) {
        var plus = wrapper.querySelector('[name="plus"]');
        if (plus) {
          var atMax = parseInt(input.value, 10) >= MAX_PER_ITEM;
          plus.disabled = atMax;
          plus.setAttribute('aria-disabled', atMax ? 'true' : 'false');
          plus.title = atMax ? MSG : '';
        }
      }
    });
  }

  function notify(text) {
    var el = document.getElementById('gk-qty-limit-msg');
    if (!el) {
      el = document.createElement('div');
      el.id = 'gk-qty-limit-msg';
      el.setAttribute('role', 'status');
      el.style.cssText = 'position:fixed;left:50%;bottom:28px;transform:translateX(-50%);z-index:99999;background:#0d1220;color:#00fff0;border:1px solid rgba(0,255,240,.45);border-radius:8px;padding:12px 20px;font-family:Inter,sans-serif;font-size:13px;font-weight:600;box-shadow:0 8px 30px rgba(0,0,0,.6);opacity:0;transition:opacity .25s;pointer-events:none;max-width:90vw;text-align:center;';
      document.body.appendChild(el);
    }
    el.textContent = text;
    el.style.opacity = '1';
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.style.opacity = '0'; }, 3200);
  }

  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('input.quantity__input, input[name="quantity"], input[name="updates[]"]')) return;
    var v = parseInt(e.target.value, 10);
    if (!isNaN(v) && v > MAX_PER_ITEM) {
      e.target.value = MAX_PER_ITEM;
      notify(MSG);
    }
    clampInputs();
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[name="plus"]') : null;
    if (!btn) return;
    var wrapper = btn.closest('quantity-input, .quantity');
    if (!wrapper) return;
    var input = wrapper.querySelector('input');
    if (input && parseInt(input.value, 10) >= MAX_PER_ITEM) {
      e.preventDefault();
      e.stopPropagation();
      notify(MSG);
    }
  }, true);

  /* Plafonne les requetes panier avant envoi.
     origFetch est TOUJOURS invoque avec window comme contexte : c'est ce qui
     manquait et qui cassait le panier (voir l'entete du fichier).
     /cart/update n'est volontairement PAS intercepte. */
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (init && init.body && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1)) {
          if (typeof init.body === 'string') {
            if (init.body.charAt(0) === '{') {
              var data = JSON.parse(init.body);
              var capped = false;
              if (typeof data.quantity === 'number' && data.quantity > MAX_PER_ITEM) { data.quantity = MAX_PER_ITEM; capped = true; }
              if (data.items && data.items.length) {
                data.items.forEach(function (it) {
                  if (it.quantity > MAX_PER_ITEM) { it.quantity = MAX_PER_ITEM; capped = true; }
                });
              }
              if (capped) { init.body = JSON.stringify(data); notify(MSG); }
            } else {
              var params = new URLSearchParams(init.body);
              var q = parseInt(params.get('quantity'), 10);
              if (!isNaN(q) && q > MAX_PER_ITEM) {
                params.set('quantity', MAX_PER_ITEM);
                init.body = params.toString();
                notify(MSG);
              }
            }
          } else if (init.body instanceof FormData) {
            var fq = parseInt(init.body.get('quantity'), 10);
            if (!isNaN(fq) && fq > MAX_PER_ITEM) {
              init.body.set('quantity', MAX_PER_ITEM);
              notify(MSG);
            }
          }
        }
      } catch (err) { /* en cas de doute, laisser passer la requete telle quelle */ }
      return origFetch.apply(window, arguments);
    };
  }

  function init() {
    clampInputs();
    try {
      new MutationObserver(function () { clampInputs(); }).observe(document.body, { childList: true, subtree: true });
    } catch (err) {}
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();